import { render, staticRenderFns } from "./Calendarv2.vue?vue&type=template&id=a4a927b4&scoped=true&"
import script from "./Calendarv2.vue?vue&type=script&lang=js&"
export * from "./Calendarv2.vue?vue&type=script&lang=js&"
import style0 from "./Calendarv2.vue?vue&type=style&index=0&id=a4a927b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a927b4",
  null
  
)

export default component.exports